import { IonContent } from '@ionic/react';
import { AlertUIConfig } from '../components/ui/alert-ui';
import { FeedbackUIConfig } from '../components/ui/feedback-ui';
import { TopLeftControlsUIConfig } from '../components/ui/hud/top-left-controls-ui';
import { IntroScreenUIConfig } from '../components/ui/intro-screen-ui';
import { QuestionType1UIConfig } from '../components/ui/question-type1-ui';
import { QuestionType2UIConfig } from '../components/ui/question-type2-ui';
import { CoreReturnToMainMenuUIConfig } from '../cvp-webgames-core/Components/ui/react/core-return-to-main-menu-ui';
import { SkipContentUIConfig } from '../components/ui/skip-content-ui';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { GeneralAARUIConfig } from '../cvp-webgames-core/Components/ui/react/core-general-aar-ui';
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from '../cvp-webgames-core/Components/ui/react/core-general-question-ui';
import { coreConstantsGeneralUIs } from '../cvp-webgames-core/Misc/CoreConstants';
import Tools from '../cvp-webgames-core/Misc/Tools';
import BaseScenario from '../cvp-webgames-core/Scenario/BaseScenario';
import BaseScenarioPart from '../cvp-webgames-core/Scenario/BaseScenarioPart';
import { constants } from '../misc/constants';
import { GameDataConfig, SingleScenarioConfig } from '../cvp-webgames-core/Misc/interfaces';
import { setFocus, setUp508, PageType, topLeftMenuProps, getSaveData, saveGame, ScoringType, updateLast508Window } from '../misc/tools';
import { CoreResumeUIConfig } from '../cvp-webgames-core/Components/ui/react/core-resume-ui';
import { MixedMediaUIConfig } from '../components/ui/mixed-media';
import { VideoSegmentManager } from '../cvp-webgames-core/VideoSegment/VideoSegmentManager';
import { SingleVideoSegmentItem, VideoSegmentItem } from '../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import { PreCacheManager } from '../cvp-webgames-core/pre-caching/pre-cache-manager';
import { PreCacheItem, PrecacheItemType, SinglePreCacheItem } from '../cvp-webgames-core/pre-caching/pre-cache-item';
import { ScenarioInfoUIConfig, SingleScenarioInfoConfig } from '../components/ui/scenario-info-ui';
import { getCompletionPercentage } from '../components/main-menu/windows/main-menu/start-scenarios-window';

export enum GameScenarioWindow508Type {
	Main,
	ResumeUI,
	ReturnToMainMenuUI,
	SimpleAccessibility,
	QuestionType1UI,
	QuestionType2UI,
	MixedMediaUI,
	ScenarioInfoUI,
	RecapUI,
	AARUI,
	FeedbackUI,
	AlertUI,
}

enum ReplayContentType {
	QuestionType1,
	QuestionType2
}

interface ReplayContent {
    type: ReplayContentType;
    config: QuestionType1UIConfig | QuestionType2UIConfig;
}

let lastChapterDataPlayed: any = undefined;
let lastMixedMediaConfigPlayed: MixedMediaUIConfig = undefined;

let current508Window = GameScenarioWindow508Type.Main;
let windows508Layers: any[] = []

const objectWindowIDs = {
    main: {
        objects: [
            'main-content-top',
            // 'main-content-bottom',
        ]
    },
    resume: {
        objects: [
            'resume-content-top',
            'resume-content-bottom',
        ]
    },
    returnToMainMenu: {
        objects: [
            'return-to-main-menu-content-top',
			'return-to-main-menu-content-bottom',
        ]
    },
    simpleAccessibility: {
        objects: [
            'simple-accessibility-content-top',
            'simple-accessibility-content-bottom',
        ]
    },
    questionType1: {
        objects: [
            'question-type-1-content-top',
            // 'question-type-1-content-bottom',
        ]
    },
    questionType2: {
        objects: [
            'question-type-2-content-top',
            // 'question-type-2-content-bottom',
        ]
    },
    mixedMedia: {
        objects: [
            'mixed-media-content-top',
            // 'mixed-media-content-bottom',
        ]
    },
    scenarioInfo: {
        objects: [
            'scenario-info-content-top',
            // 'scenario-info-content-bottom',
        ]
    },
    recap: {
        objects: [
            'recap-content-top',
            // 'recap-content-bottom',
        ]
    },
    aar: {
        objects: [
            'aar-content-top',
            // 'aar-content-bottom',
        ]
    },
    feedback: {
        objects: [
            'feedback-content-top',
            // 'feedback-content-bottom',
        ]
    },
    alert: {
        objects: [
            'alert-content-top',
            'alert-content-bottom',
        ]
    }
}

const setUpScenario508 = () => {
    windows508Layers[GameScenarioWindow508Type.Main] = {
        objects: objectWindowIDs.main.objects
    };
    windows508Layers[GameScenarioWindow508Type.ResumeUI] = {
        objects: objectWindowIDs.resume.objects
    };
    windows508Layers[GameScenarioWindow508Type.ReturnToMainMenuUI] = {
        objects: objectWindowIDs.returnToMainMenu.objects
    };
    windows508Layers[GameScenarioWindow508Type.SimpleAccessibility] = {
        objects: objectWindowIDs.simpleAccessibility.objects
    };

    windows508Layers[GameScenarioWindow508Type.QuestionType1UI] = {
        objects: objectWindowIDs.questionType1.objects
    };
    windows508Layers[GameScenarioWindow508Type.QuestionType2UI] = {
        objects: objectWindowIDs.questionType2.objects
    };
    windows508Layers[GameScenarioWindow508Type.MixedMediaUI] = {
        objects: objectWindowIDs.mixedMedia.objects
    };
    windows508Layers[GameScenarioWindow508Type.ScenarioInfoUI] = {
        objects: objectWindowIDs.scenarioInfo.objects
    };
    windows508Layers[GameScenarioWindow508Type.RecapUI] = {
        objects: objectWindowIDs.recap.objects
    };
    windows508Layers[GameScenarioWindow508Type.AARUI] = {
        objects: objectWindowIDs.aar.objects
    };
    windows508Layers[GameScenarioWindow508Type.FeedbackUI] = {
        objects: objectWindowIDs.feedback.objects
    };
    windows508Layers[GameScenarioWindow508Type.AlertUI] = {
        objects: objectWindowIDs.alert.objects
    };
}

const getCurrent508WindowLayer = () => {
	return windows508Layers[current508Window];
}

const set508Window = (window: GameScenarioWindow508Type) => {
    current508Window = window;
    setFocus(getCurrent508WindowLayer().objects[0]);
}

setUpScenario508();
setUp508(() => getCurrent508WindowLayer())

set508Window(GameScenarioWindow508Type.Main);

class TemplatePreCacheScenario extends PreCacheItem {
    public get title(): string {
        return 'Template Scenario';
    }
    public getItems(): SinglePreCacheItem[] {
        return [
        ];
    }
}

export class GameBaseScenario extends BaseScenario {
    
    public uiWrapper = new UIWrapper(this);

    public correctScoreOverrideForQuestion3Part1 = 3;
    public correctScoreOverrideForQuestion3Part2 = 2;

    public introScreenInfo(): IntroScreenUIConfig {
        throw new Error('introScreenInfo must be implemented');
    }

    public update508Window(window: GameScenarioWindow508Type) {
        set508Window(window);
    }

    public scenarioId(): PageType {
        throw new Error('scenarioId must be implemented');
    }

    public UpdateScoreFromCorrectAnswer(isCorrect: boolean, overrideCorrectScore?: number, overrideIncorrectScore?: number) {
        var correctScore = typeof overrideCorrectScore === 'undefined' ? ScoringType.good : overrideCorrectScore;
        var incorrectScore = typeof overrideIncorrectScore === 'undefined' ? ScoringType.bad : overrideIncorrectScore;

        var savedData = getSaveData();
        const scenario = this.getCurrentScenarioFromSaveData(savedData);
        scenario.score += (isCorrect ? correctScore : incorrectScore);
        if(!isCorrect) {
            scenario.gaugeValue--;
        }
        saveGame(savedData);
    }

    public getCurrentScenarioFromSaveData(savedData: GameDataConfig) {
        return savedData.scenarios.filter(s => s.scenarioWindow === this.scenarioId())[0];
    }

    private getNextScenarioFromSaveData(savedData: GameDataConfig) {
        var currScenario = this.getCurrentScenarioFromSaveData(savedData);
        var nextScenarioIndex = savedData.scenarios.indexOf(currScenario)+1;
        return savedData.scenarios[nextScenarioIndex];
    }

    public onChoiceSubmittedQuestionType1 (selectedOption: GeneralQuestionUIConfigOption, uiSubtitle: string, question: GeneralQuestionUIConfig, onNextStep: () => void, onRetry: () => void, overrideCorrectScore?: number, overrideIncorrectScore?: number, imgUrl?: string, mentorUrl?: string, mentorCorrectChapterId?: string, mentorIncorrectChapterId1?: string, mentorIncorrectChapterId2?: string, titleCheck?: string) {
        const displayFeedback = (onDone: () => void) => {
            const _onDone = () => {
                this.UpdateScoreFromCorrectAnswer(selectedOption.isCorrect, overrideCorrectScore,overrideIncorrectScore);
                var savedData = getSaveData();
                var correctScore = typeof overrideCorrectScore === 'number' ? overrideCorrectScore : ScoringType.good;
                var incorrectScore = typeof overrideIncorrectScore === 'number' ? overrideIncorrectScore : ScoringType.bad;
                this.getCurrentScenarioFromSaveData(savedData).aarEntries.push({
                    questionTitle: question.questionTitle,
                    selectedOption: selectedOption.title + ': ' + selectedOption.description,
                    feedback: selectedOption.feedbackHtml,
                    isCorrect: selectedOption.isCorrect,
                    scoreAwarded: selectedOption.isCorrect ? correctScore : incorrectScore,
                    scorePossible: correctScore
                });
                saveGame(savedData);
                this.blurFadeOut();
                onDone();
            }
            if(selectedOption.feedbackHtml) {
                this.uiWrapper.displayFeedback({
                    onButtonClicked: () => {
                        _onDone();
                    },
                    selectedOption: selectedOption,
                    title: this.props.name,
                    subtitle: uiSubtitle,
                    imgUrl: imgUrl,
                    talkVideoUrl: mentorUrl,
                    talkVideoChapterId: selectedOption.isCorrect ? mentorCorrectChapterId : ((selectedOption.title === titleCheck) ? (mentorIncorrectChapterId1) : (mentorIncorrectChapterId2))
                });
            } else {
                _onDone();
            }
        }
        if(selectedOption.isCorrect) {
            displayFeedback(onNextStep);
        } else {
            displayFeedback(onRetry);
        }
    }

    public replayContent(replayContent: ReplayContent) {
        if(lastChapterDataPlayed) {
            this.uiWrapper.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.QuestionType1UI);
            Tools.forceRerenderUI(constants.uiNames.QuestionType2UI);
            this.blurFadeOut();

            const onDone = () => {
                switch(replayContent.type) {
                    case ReplayContentType.QuestionType1:
                        this.uiWrapper.displayQuestonType1UI(replayContent.config as QuestionType1UIConfig, -1);
                        break;
                    case ReplayContentType.QuestionType2:
                        this.uiWrapper.displayQuestonType2UI(replayContent.config as QuestionType2UIConfig, -1);
                        break;
                }
            };

            if(lastMixedMediaConfigPlayed) {
                lastMixedMediaConfigPlayed.onContinueClicked = () => onDone();
                this.uiWrapper.displayMixedMediaUI(lastMixedMediaConfigPlayed);
            } else {
                this.playVideoChapter(lastChapterDataPlayed.partId,
                    lastChapterDataPlayed.chapterId,
                    // lastChapterDataPlayed.onDone,
                    onDone,
                    lastChapterDataPlayed.loop)
            }
            
        }
    }

    public playVideoChapter(partId: string, chapterId: string, onDone: () => void, loop?: boolean): void {
        if(!loop) { //typical loops are not expected to contain any substantial content
            lastChapterDataPlayed = {
                partId: partId,
                chapterId: chapterId,
                onDone: onDone,
                loop: loop
            };
        }

        let skipContentUIId = '';
        const context = this;

        const _onDone = () => {
            context.uiWrapper.destroyInstance(skipContentUIId);
            Tools.forceRerenderUI(constants.uiNames.SkipContentUI);
            (this.gameManager.environment as VideoEnvironment).pauseCurrentSequence();
            if(onDone) {
                onDone();
            }
        }
        if(chapterId === 'End Frame') {
            setTimeout(() => {
                _onDone()
            }, 100);
        }

        skipContentUIId = this.uiWrapper.displaySkipContentUI({
            onSkipContentClicked: _onDone
        });
		
        super.playVideoChapter(partId, chapterId, _onDone, loop);
	}

    public calculateIfScenarioPassed() {
        var scenarioPassed = false;
        var savedData = getSaveData();
        var currentScenario = this.getCurrentScenarioFromSaveData(savedData);
        scenarioPassed = (currentScenario.score/currentScenario.maxScore) >= 0;

        return scenarioPassed;
    }

    public endScenario() {
		var scenarioPassed = this.calculateIfScenarioPassed();
        var savedData = getSaveData();
        var currentScenario = this.getCurrentScenarioFromSaveData(savedData);
        var nextScenario = this.getNextScenarioFromSaveData(savedData);
        savedData.lastVisitedScenarioIndx=-1;

		if(scenarioPassed === true) {
			currentScenario.isCompleted = true;
            if(nextScenario) {
                nextScenario.isLocked = false;
            }
		} else {
            currentScenario.aarEntries = [];
            currentScenario.area = -1;
            currentScenario.score = 0;
            currentScenario.gaugeValue = currentScenario.gaugeMax;
        }
        saveGame(savedData);
        super.endScenario();
	}

    public onChoiceSubmittedQuestionType2 (isCorrect: boolean, feedback: string, selectedTitle: string, uiSubtitle: string, question: QuestionType2UIConfig, onNextStep: () => void, onRetry: () => void, overrideCorrectScore?: number, overrideIncorrectScore?: number, imgUrl?: string, mentorUrl?: string, mentorCorrectChapterId?: string, mentorIncorrectChapterId?: string) {
        const displayFeedback = (onDone: () => void) => {
            const _onDone = () => {
                this.UpdateScoreFromCorrectAnswer(isCorrect, overrideCorrectScore,overrideIncorrectScore);
                var savedData = getSaveData();
                var correctScore = typeof overrideCorrectScore === 'number' ? overrideCorrectScore : ScoringType.good;
                var incorrectScore = typeof overrideIncorrectScore === 'number' ? overrideIncorrectScore : ScoringType.bad;
                this.getCurrentScenarioFromSaveData(savedData).aarEntries.push({
                    questionTitle: question.question,
                    selectedOption: selectedTitle,
                    isCorrect: isCorrect,
                    feedback: feedback,
                    scoreAwarded: isCorrect ? correctScore : incorrectScore,
                    scorePossible: correctScore
                });
                saveGame(savedData);
                this.blurFadeOut();
                onDone();
            }
            if(feedback) {
                this.uiWrapper.displayFeedback({
                    onButtonClicked: () => {
                        _onDone();
                    },
                    selectedOption: {
                        score: undefined,
                        feedbackHtml: feedback,
                        description: undefined,
                        isCorrect: isCorrect,
                        title: selectedTitle
                    },
                    title: this.props.name,
                    subtitle: uiSubtitle,
                    imgUrl: imgUrl,
                    talkVideoUrl: mentorUrl,
                    talkVideoChapterId: isCorrect ? mentorCorrectChapterId : mentorIncorrectChapterId
                });
            } else {
                _onDone();
            }
        }
        if(isCorrect) {
            displayFeedback(onNextStep);
        } else {
            displayFeedback(onRetry);
        }
    }

    public loadVideoFromUrl(url: string, onDone: () => void) {
        let obj: any = {
            partId: '',
            url: [url],
        };
        // this.loadAllVideosInEnvironment(obj, onReady);
        this.loadAllVideosInEnvironment(obj, () => onDone());
    }

    public getScenarioInfo(): SingleScenarioInfoConfig {
        throw new Error('getScenarioInfo must be implemented')
	}

    public getScenarioVideoURL(): string {
        throw new Error('getScenarioVideoURL must be implemented')
	}

    public getMentorVideoURLs(): SingleVideoSegmentItem[] {
        throw new Error('getMentorVideoURLs must be implemented')
	}

    public resumeScenarioFromArea(areaIndx: number): void {
        throw new Error('resumeScenarioFromArea must be implemented')
	}

    

    public init(onDoneLoading: () => void, onDone: () => void): void {
        (window as any)['set-508-window-return-to-main-menu-on'] = () => {
            set508Window(GameScenarioWindow508Type.ReturnToMainMenuUI);
        }
        (window as any)['set-508-window-return-to-main-menu-off'] = () => {
            updateLast508Window();
        }
        (window as any)['set-508-window-simple-accessibility-on'] = () => {
            set508Window(GameScenarioWindow508Type.SimpleAccessibility);
        }
        (window as any)['set-508-window-simple-accessibility-off'] = () => {
            updateLast508Window();
        }
        this.gameManager.customData.scenario = this;
        const context = this;
        this.uiWrapper.displayTopLeftControlsUI(topLeftMenuProps(context, null, () => {
            if((window as any)['forceEntireUIRefresh']) {
                (window as any)['forceEntireUIRefresh']();
            }
        }));
        var introData = this.introScreenInfo();
        var nextData = getSaveData();
        var currentScenario = this.getCurrentScenarioFromSaveData(nextData);
        nextData.lastVisitedScenarioIndx = nextData.scenarios.indexOf(currentScenario);
        saveGame(nextData);
        this.loadVideoFromUrl(this.getScenarioVideoURL(), () => {
	        const videoSegmentManager = new PreCacheManager();
            const templatePrecacheInstance = new TemplatePreCacheScenario();
            (templatePrecacheInstance as any)['getItems'] = () => {
                const items = this.getMentorVideoURLs();
                for(var i = 0; i < items.length; i++) {
                    (items[i] as any)['type'] = PrecacheItemType.Video;
                }
                return items;
            }
            videoSegmentManager.registerItem(templatePrecacheInstance);
            videoSegmentManager.loadAllItems(() => {

            }, () => {
                this.uiWrapper.destroyAllUIInstances();
                Tools.forceRerenderUI(constants.uiNames.LoadingUI)
                if(this.shouldLoadScenario()) {
                    //every video currently gets played on the first part
                    const partId = 'Scenario Part 0';
                    context.playVideoChapter(partId, 'End Frame', () => {
                    }, false)

                    const onDone = () => {
                        this.resumeScenarioFromArea(currentScenario.area);
                    }

                    lastChapterDataPlayed = {
                        partId: partId,
                        chapterId: 'Chapter 1',
                        onDone: onDone,
                        loop: false
                    };

                    onDone();
                } else {
                    this.uiWrapper.displayScenarioInfoUI({
                        getCompletionPercentage,
                        onReturnToMainMenuClicked: () => {
                            Tools.updateWindow(PageType.Scenarios)
                        },
                        onStartScenarioClicked: () => {
                            const id = this.uiWrapper.displayIntroScreenUI({
                                title: introData.title,
                                subtitle: introData.subtitle,
                                htmlData: introData.htmlData,
                                name: introData.name,
                                position: introData.position,
                                time: introData.time,
                                place: introData.place,
                                desc: introData.desc,
                                repeat: introData.repeat,
                                okButton: introData.okButton,
                                mentorChapter: undefined,
                                mentorUrl: undefined,
                                onStartScenarioClicked: () => {
                                    currentScenario = this.getCurrentScenarioFromSaveData(nextData);
                                    nextData = getSaveData()
                                    currentScenario.score = 0;
                                    currentScenario.gaugeValue = currentScenario.gaugeMax;
                                    saveGame(nextData);
                                    context.uiWrapper.destroyInstance(id);
                                    Tools.forceRerenderUI(constants.uiNames.IntroScreenUI);
                                    onDone();
                                }
                            })
                        },
                        scenario: this.getScenarioInfo(),
                        scenarioSaveData: this.getCurrentScenarioFromSaveData(getSaveData())
                    })
                    
                    onDoneLoading();
                }
            })
        });
    }

    public shouldLoadScenario(): boolean {
        var savedData = getSaveData();
        var currentScenario = this.getCurrentScenarioFromSaveData(savedData);
        return typeof currentScenario.area !== 'undefined' && currentScenario.area > -1;
	}

    public setAreaForCurrentScenario(area: number) {
        if(area < 0) {
            return;
        }
        var savedData = getSaveData();
        var currentScenario = this.getCurrentScenarioFromSaveData(savedData);
        currentScenario.area = area;
        saveGame(savedData);
    }
}

export class UIWrapper {
    constructor(private _sceanrio: GameBaseScenario) {
    }

    public displayTopLeftControlsUI(config: TopLeftControlsUIConfig): string {
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.TopLeftControlsUI, config);
        Tools.forceRerenderUI(constants.uiNames.TopLeftControlsUI);
        set508Window(GameScenarioWindow508Type.Main)
        return res;
    }

    public displaySkipContentUI(config: SkipContentUIConfig): string {
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.SkipContentUI, config);
        Tools.forceRerenderUI(constants.uiNames.SkipContentUI);
        return res;
    }

    public displayAlert(config: AlertUIConfig): string {
        let context = this;
        let oldOkOnClicked = config.okButton.onClick;
        config.okButton.onClick = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.AlertUI);
            set508Window(GameScenarioWindow508Type.Main);
            
            if(oldOkOnClicked) {
                oldOkOnClicked();
            }
        }; 
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.AlertUI, config);
        Tools.forceRerenderUI(constants.uiNames.AlertUI);
        set508Window(GameScenarioWindow508Type.AlertUI);
        return res;
    }

    public displayAAR(): string {
        let context = this;
        const savedData = getSaveData();
        const currentScenario = this._sceanrio.getCurrentScenarioFromSaveData(savedData);
        const config: GeneralAARUIConfig = {
            entries: currentScenario.aarEntries,
            onGetIfPassed: () => {
                return this._sceanrio.calculateIfScenarioPassed();
            },
            onCloseClicked: () => {
                context.destroyAllUIInstances();
                Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralAAR);
                this._sceanrio.endScenario();
                set508Window(GameScenarioWindow508Type.Main);
            }
        };
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(coreConstantsGeneralUIs.CoreGeneralAAR, config);
        Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralAAR);
        set508Window(GameScenarioWindow508Type.AARUI);
        return res;
    }

    public displayScenarioInfoUI(config: ScenarioInfoUIConfig): string {
        let context = this;
        let oldOnReturnToMainMenuClicked = config.onReturnToMainMenuClicked;
        config.onReturnToMainMenuClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ScenarioInfoUI);
            set508Window(GameScenarioWindow508Type.Main);
            
            if(oldOnReturnToMainMenuClicked) {
                oldOnReturnToMainMenuClicked();
            }
        }; 

        let oldOnStartScenarioClicked = config.onStartScenarioClicked;
        config.onStartScenarioClicked = (pageType: PageType) => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ScenarioInfoUI);
            set508Window(GameScenarioWindow508Type.Main);
            
            if(oldOnStartScenarioClicked) {
                oldOnStartScenarioClicked(pageType);
            }
        }; 
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ScenarioInfoUI, config);
        Tools.forceRerenderUI(constants.uiNames.ScenarioInfoUI);
        set508Window(GameScenarioWindow508Type.ScenarioInfoUI);
        return res;
    }

    public displayFeedback(config: FeedbackUIConfig): string {
        let context = this;
        let oldOnButtonClicked = config.onButtonClicked;
        config.onButtonClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.FeedbackUI);
            // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralFeedback);
            set508Window(GameScenarioWindow508Type.Main);
            
            if(oldOnButtonClicked) {
                oldOnButtonClicked();
            }
        }; 
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.FeedbackUI, config);
        Tools.forceRerenderUI(constants.uiNames.FeedbackUI);
        // let res = this._sceanrio.gameManager.UiManager.createUIInstance(coreConstantsGeneralUIs.CoreGeneralFeedback, config);
        // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralFeedback);
        set508Window(GameScenarioWindow508Type.FeedbackUI);
        return res;
    }

    public displayQuestonType1UI(config: QuestionType1UIConfig, area: number): string {
        let context = this;
        this._sceanrio.setAreaForCurrentScenario(area);

        const savedData = getSaveData();
        const currentScenario = this._sceanrio.getCurrentScenarioFromSaveData(savedData);
        config.percentage = currentScenario.gaugeValue / currentScenario.gaugeMax;

        config.onReplayContentClicked = () => {
            set508Window(GameScenarioWindow508Type.Main);
            context._sceanrio.replayContent({
                type: ReplayContentType.QuestionType1,
                config: config
            });
        }

        let oldonSubmitClicked = config.onSubmitClicked;
        config.onSubmitClicked = (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.QuestionType1UI);
            // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralQuestion);
            set508Window(GameScenarioWindow508Type.Main);
            
            if(oldonSubmitClicked) {
                oldonSubmitClicked(allOptions, selectedChoices, parentQuestionConfig);
            }
        }; 
        this._sceanrio.blurFadeIn();
        // config.multipleChoice = true;
        // let res = this._sceanrio.gameManager.UiManager.createUIInstance(coreConstantsGeneralUIs.CoreGeneralQuestion, config);
        // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralQuestion);
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.QuestionType1UI, config);
        Tools.forceRerenderUI(constants.uiNames.QuestionType1UI);
        set508Window(GameScenarioWindow508Type.QuestionType1UI);

        return res;
    }

    public displayQuestonType2UI(config: QuestionType2UIConfig, area: number): string {
        let context = this;
        this._sceanrio.setAreaForCurrentScenario(area);

        const savedData = getSaveData();
        const currentScenario = this._sceanrio.getCurrentScenarioFromSaveData(savedData);
        config.percentage = currentScenario.gaugeValue / currentScenario.gaugeMax;

        config.onReplayContentClicked = () => {
            set508Window(GameScenarioWindow508Type.Main);
            context._sceanrio.replayContent({
                type: ReplayContentType.QuestionType2,
                config: config
            });
        }

        let oldonSubmitClicked = config.onSubmitClicked;
        config.onSubmitClicked = (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.QuestionType2UI);
            set508Window(GameScenarioWindow508Type.Main);
            
            if(oldonSubmitClicked) {
                oldonSubmitClicked(isCorrect, feedback, selectedTitle, parentQuestion);
            }
        }; 
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.QuestionType2UI, config);
        this._sceanrio.blurFadeIn();
        Tools.forceRerenderUI(constants.uiNames.QuestionType2UI);
        set508Window(GameScenarioWindow508Type.QuestionType2UI);
        return res;
    }

    public displayMixedMediaUI(config: MixedMediaUIConfig): string {
        let context = this;
        let oldOnContinueClicked = config.onContinueClicked;
        lastMixedMediaConfigPlayed = config;
        config.onContinueClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.MixedMediaUI);
            set508Window(GameScenarioWindow508Type.Main);
            if(oldOnContinueClicked) {
                oldOnContinueClicked();
            }
        }; 

        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.MixedMediaUI, config);
        Tools.forceRerenderUI(constants.uiNames.MixedMediaUI);
        set508Window(GameScenarioWindow508Type.MixedMediaUI)
        return res;
    }

    public displayIntroScreenUI(config: IntroScreenUIConfig): string {
        let context = this;
        let OldOnStartScenarioClicked = config.onStartScenarioClicked;
        config.onStartScenarioClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.IntroScreenUI);
            
            if(OldOnStartScenarioClicked) {
                OldOnStartScenarioClicked();
            }
            set508Window(GameScenarioWindow508Type.Main);
        }; 

        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.IntroScreenUI, config);
        Tools.forceRerenderUI(constants.uiNames.IntroScreenUI);
        set508Window(GameScenarioWindow508Type.RecapUI)
        return res;
    }

    public displayReturnToMainMenu(config: CoreReturnToMainMenuUIConfig): string {
        let context = this;
        let oldGoToMainMenuClicked = config.onGoToMainMenuClicked;
        config.onGoToMainMenuClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ReturnToMainMenuUI);
            
            if(oldGoToMainMenuClicked) {
                oldGoToMainMenuClicked();
            }
            set508Window(GameScenarioWindow508Type.Main);
        }; 

        let oldOnCancelClicked = config.onCancelClicked;
        config.onCancelClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ReturnToMainMenuUI);
            
            if(oldOnCancelClicked) {
                oldOnCancelClicked();
            }
            set508Window(GameScenarioWindow508Type.Main);
        }; 
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ReturnToMainMenuUI, config);
        Tools.forceRerenderUI(constants.uiNames.ReturnToMainMenuUI);
        set508Window(GameScenarioWindow508Type.ReturnToMainMenuUI)
        return res;
    }

    public displayResumeUI(config: CoreResumeUIConfig): string {
        // let oldOnButtonClicked = config.onButtonClicked;
        // let context = this;
        // config.onButtonClicked = () => {
        //     context.destroyAllUIInstances();
        //     Tools.forceRerenderUI(constants.uiNames.SampleUI);
            
        //     if(oldOnButtonClicked) {
        //         oldOnButtonClicked();
        //     }
        //     set508Window(Window508Type.Main);
        // }; 
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ResumeUI, config);
        Tools.forceRerenderUI(constants.uiNames.ResumeUI);
        set508Window(GameScenarioWindow508Type.ResumeUI)
        return res;
    }

    public destroyAllUIInstances(absolutelyEverySingleUI?: boolean) {
        set508Window(GameScenarioWindow508Type.Main);
        this._sceanrio.gameManager.UiManager.destroyAllInstances(absolutelyEverySingleUI ? [] :  [constants.uiTags.Hud]);
    }

    public destroyInstance(id: string) {
        set508Window(GameScenarioWindow508Type.Main);
        this._sceanrio.gameManager.UiManager.destroyUIInstanceById(id);
    }
}

export interface GeneralPartConfig {
	videoUrl: string;
}

export interface BaseGeneralConfig {
}